import { SVGProps } from "react";

export function ECheck(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26 26"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M1 0C.449 0 0 .449 0 1v14c0 1.094.906 2 2 2h9.531a1 1 0 1 0 0-2H2V5h22v10h-3.5a1 1 0 1 0 0 2H24c1.094 0 2-.906 2-2V1c0-.551-.449-1-1-1zm3.219 7A1.004 1.004 0 0 0 4.5 9h8a1 1 0 1 0 0-2h-8a1 1 0 0 0-.094 0a1 1 0 0 0-.093 0a1 1 0 0 0-.094 0m13 0a1.004 1.004 0 0 0 .281 2h4a1 1 0 1 0 0-2h-4a1 1 0 0 0-.094 0a1 1 0 0 0-.093 0a1 1 0 0 0-.094 0m-13 3a1.004 1.004 0 0 0 .281 2h8a1 1 0 1 0 0-2h-8a1 1 0 0 0-.094 0a1 1 0 0 0-.093 0a1 1 0 0 0-.094 0m16.625.5a.5.5 0 0 0-.188.156l-.562.563c-1.054.137-2.905 1.312-3.375 1.781l-5.313 5.313l2.344 2.343l5.313-5.312c.393-.394 1.653-2.398 1.75-3.469l.53-.531a.5.5 0 0 0-.437-.844zm-10.375 8.719l-3.844 3.843c-.48.48-.707 1.794-.063 2.438s1.819.493 2.407-.094l3.844-3.843zm4.469.968a.8.8 0 0 0-.47.25l-4.03 4a.8.8 0 1 0 1.124 1.125l4.032-4a.8.8 0 0 0-.656-1.375"
      ></path>
    </svg>
  );
}
